<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">护理排班添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <!-- <el-col :span="12" class="item">
                                <el-form-item label="护理排班时间"  required prop="time">
                                    <el-date-picker
                                        v-model="addForm.time"
                                        type="date"
                                        placeholder="选择日期"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="pickerOption"
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col> -->
                            <el-col :span="12" class="item">
                                <el-form-item label="护理排班类型"  required prop="type">
                                    <el-select v-model="addForm.type" placeholder="" @change="selectType" style="width:100%">
                                        <el-option
                                                v-for="(item,i) in typeValue"
                                                :key="i"
                                                :label="item"
                                                :value="i">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            
                            <el-col :span="24" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>{{schedulName1}}</span>
                                    </div>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护士"  required prop="nurseCodeArr1">
                                            <el-select
                                                v-model="addForm.nurseCodeArr1"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护士">
                                                <el-option
                                                    v-for="item in nurseList"
                                                    :key="item.nurseCode"
                                                    :label="item.name"
                                                    :value="item.nurseCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护工"  required prop="nurseAideCodeArr1">
                                            <el-select
                                                v-model="addForm.nurseAideCodeArr1"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护工">
                                                <el-option
                                                    v-for="item in nurseAideList"
                                                    :key="item.nurseAideCode"
                                                    :label="item.name"
                                                    :value="item.nurseAideCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-card>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>{{schedulName2}}</span>
                                    </div>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护士"  required prop="nurseCodeArr2">
                                            <el-select
                                                v-model="addForm.nurseCodeArr2"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护士">
                                                <el-option
                                                    v-for="item in nurseList"
                                                    :key="item.nurseCode"
                                                    :label="item.name"
                                                    :value="item.nurseCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护工"  required prop="nurseAideCodeArr2">
                                            <el-select
                                                v-model="addForm.nurseAideCodeArr2"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护工">
                                                <el-option
                                                    v-for="item in nurseAideList"
                                                    :key="item.nurseAideCode"
                                                    :label="item.name"
                                                    :value="item.nurseAideCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-card>
                            </el-col>
                            <el-col :span="24" class="item" v-if="addForm.type>0">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>{{schedulName3}}</span>
                                    </div>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护士"  required prop="nurseCodeArr3">
                                            <el-select
                                                v-model="addForm.nurseCodeArr3"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护士">
                                                <el-option
                                                    v-for="item in nurseList"
                                                    :key="item.nurseCode"
                                                    :label="item.name"
                                                    :value="item.nurseCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护工"  required prop="nurseAideCodeArr3">
                                            <el-select
                                                v-model="addForm.nurseAideCodeArr3"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护工">
                                                <el-option
                                                    v-for="item in nurseAideList"
                                                    :key="item.nurseAideCode"
                                                    :label="item.name"
                                                    :value="item.nurseAideCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['nurseList','nurseAideList'],
        data() {
            return {
                loading: false,
                floor:null,
                schedulName1:'白班',
                schedulName2:'夜班',
                schedulName3:'晚班',
                typeValue:['两班制','三班制'],
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    timeArr:[],
                    type:0,
                    nurseCodeArr1:[],
                    nurseCodeArr2:[],
                    nurseCodeArr3:[],
                    nurseAideCodeArr1:[],
                    nurseAideCodeArr2:[],
                    nurseAideCodeArr3:[],
                    schedulingPlan:[],
                },
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    },
                },
                rules:{
                    time:[
                        { required: true, message: '请选择时间', trigger: 'blur' },
                    ],
                    type:[{required: true, message: '请选择护理排班类型', trigger: 'blur' }],
                    nurseCodeArr1:[{ required: true, message: '请选择护士', trigger: 'blur' }],
                    nurseCodeArr2:[{ required: true, message: '请选择护士', trigger: 'blur' }],
                    nurseCodeArr3:[{ required: true, message: '请选择护士', trigger: 'blur' }],
                    nurseAideCodeArr1:[{ required: true, message: '请选择护工', trigger: 'blur' }],
                    nurseAideCodeArr2:[{ required: true, message: '请选择护工', trigger: 'blur' }],
                    nurseAideCodeArr3:[{ required: true, message: '请选择护工', trigger: 'blur' }],
                }
            }
        },

        methods: {
            init(dateList){
                this.$refs.addForm.resetFields();
                this.selectType(this.addForm.type)
                this.addForm.timeArr=dateList
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        if(this.addForm ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            selectType(e){
                if(e==1){
                    this.schedulName1='早班'
                    this.schedulName2='中班'
                }else{
                    this.schedulName1='白班'
                    this.schedulName2='夜班'
                }
            },
            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.addForm.schedulingPlan.push({nurseCodeArr:this.addForm.nurseCodeArr1,nurseAideCodeArr:this.addForm.nurseAideCodeArr1})
                this.addForm.schedulingPlan.push({nurseCodeArr:this.addForm.nurseCodeArr2,nurseAideCodeArr:this.addForm.nurseAideCodeArr2})
                if(this.addForm.type>0){
                    this.addForm.schedulingPlan.push({nurseCodeArr:this.addForm.nurseCodeArr3,nurseAideCodeArr:this.addForm.nurseAideCodeArr3})
                }
                this.addForm.type=this.addForm.type+2
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"NursingScheduling/AddMany",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width:800px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body /deep/ .el-card__body{
                padding: 20px 0;
            }
            .box-card{
                margin: 10px 0;
            }
            .dishesPlanAdd{
                float: right;transform: translate(0px, -9px);
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 60vh;
                overflow-y: auto;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
